import { TWhiteLabelStore } from '../white-label.model';
import { resolveNavItemHoverColors } from './resolve-nav-item-hover-colors';

function applyColor(themeWrapper: HTMLBodyElement, property: string, color: string): void {
  if (!color) {
    themeWrapper.style.removeProperty(property);
    return;
  }

  themeWrapper.style.setProperty(property, color);
}

export function setNavItemHoverColors(
  themeWrapper: HTMLBodyElement,
  whiteLabel: TWhiteLabelStore,
): void {
  const hoverColors = resolveNavItemHoverColors(whiteLabel.data);

  applyColor(themeWrapper, '--nav-item-hover-font', hoverColors.font);
  applyColor(themeWrapper, '--nav-item-hover-border', hoverColors.border);
  applyColor(themeWrapper, '--nav-item-active-hover-bg', hoverColors.activeBackground);
  applyColor(themeWrapper, '--nav-item-hover-icon', hoverColors.icon);
}

export function clearNavItemHoverColors(themeWrapper: HTMLBodyElement): void {
  themeWrapper.style.removeProperty('--nav-item-hover-font');
  themeWrapper.style.removeProperty('--nav-item-hover-border');
  themeWrapper.style.removeProperty('--nav-item-active-hover-bg');
  themeWrapper.style.removeProperty('--nav-item-hover-icon');
}
